export default {
  'history.panel.menu': {
    ko: '선택된 메뉴',
    ja: '選択されたメニュー',
    en: 'Selected Menu',
  },
  'history.filter.username': {
    ko: "사용자ID 조건 입력 ('%'허용)",
    ja: "ユーザーIDの条件を入力('％'許可)",
    en: "Enter a User ID...(with '%')",
  },
  'history.panel.logon': {
    ko: '선택된 로그온 이력',
    ja: '選択されたログオン履歴',
    en: 'Selected Logon History',
  },
  'hist.title.avg.proc': {
    ko: 'Ø Proc',
    ja: 'Ø Proc',
    en: 'Ø Proc',
  },
  'hist.title.avg.rollin': {
    ko: 'Ø Roll in',
    ja: 'Ø ロールイン',
    en: 'Ø Roll in',
  },
  'history.filter.report': {
    ko: "Report 명 조건 입력 ('%'허용)",
    ja: "レポート名の条件を入力('％'許可)",
    en: "Enter a Report name...(with '%')",
  },
  'history.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
  },
  'history.logonTerm': {
    ko: '로그온 기간',
    ja: 'ログオン期間',
    en: 'Logon Term',
  },
  'hist.title.avg.loadgen': {
    ko: 'Ø Load+Gen',
    ja: 'Ø Load+Gen',
    en: 'Ø Load+Gen',
  },
  'hist.title.avg.rt': {
    ko: 'Ø R.T.',
    ja: 'Ø R.T.',
    en: 'Ø R.T.',
  },
  'hist.title.avg.cpu': {
    ko: 'Ø CPU',
    ja: 'Ø CPU',
    en: 'Ø CPU',
  },
  'history.panel.tx': {
    ko: '선택된 트랜잭션',
    ja: '選択されたトランザクション',
    en: 'Selected Transaction',
  },
  'history.panel.tcrp': {
    ko: '선택된 T-Code / Report',
    ja: '選択されたTコード/レポート',
    en: 'Selected T-Code / Report',
  },
  'hist.title.avg.rfc': {
    ko: 'Ø RFC',
    ja: 'Ø RFC',
    en: 'Ø RFC',
  },
  'history.panel.term': {
    ko: '선택된 기간',
    ja: '選択された期間',
    en: 'Selected Term',
  },
  'history.instance': {
    ko: 'AP',
    ja: 'AP',
    en: 'AP',
  },
  'hist.title.avg.gui': {
    ko: 'Ø GUI',
    ja: 'Ø GUI',
    en: 'Ø GUI',
  },
  'history.section': {
    ko: '구간별 응답시간',
    ja: '区間別応答時間',
    en: 'R.T. devided by sections',
  },
  'history.org': {
    ko: '조직도',
    ja: '組織図',
    en: 'Organization Hierarchy',
  },
  'hist.title.avg.wait': {
    ko: 'Ø Wait',
    ja: 'Ø 待機',
    en: 'Ø Wait',
  },
  'hist.title.avg.fenet': {
    ko: 'Ø F.E.Net',
    ja: 'Ø F.E.Net',
    en: 'Ø F.E.Net',
  },
  'history.alert.account': {
    ko: 'SAP 사용자 ID를 입력하세요.',
    ja: 'SAPのユーザーIDを入力してください。',
    en: "Please, enter the SAP's account.",
  },
  'hist.title.avg.lock': {
    ko: 'Ø Lock',
    ja: 'Ø ロック',
    en: 'Ø Lock',
  },
  'history.tcode': {
    ko: 'T-Code / Report',
    ja: 'Tコード/レポート',
    en: 'T-Code / Report',
  },
  'history.end': {
    ko: '종료 일시',
    ja: '終了日時',
    en: 'End DateTime',
  },
  'history.Øsection': {
    ko: '구간별 Ø 응답시간',
    ja: '区間別Ø応答時間',
    en: 'Ø R.T. devided by sections',
  },
  'history.panel.user': {
    ko: '선택된 사용자',
    ja: '選択されたユーザー',
    en: 'Selected User',
  },
  'history.logonTime': {
    ko: '로그인 일시',
    ja: 'ログイン日時',
    en: 'Logon DateTime',
  },
  'history.menu': {
    ko: '시스템 메뉴',
    ja: 'システムメニュー',
    en: 'System Menu',
  },
  'history.app': {
    ko: 'App. 계층도',
    ja: 'アプリ階層図',
    en: 'App. Hieracy',
  },
  'history.logoffTime': {
    ko: '로그오프 일시',
    ja: 'ログオフ日時',
    en: 'Logoff DateTime',
  },
  'hist.title.avg.db': {
    ko: 'Ø DB',
    ja: 'Ø DB',
    en: 'Ø DB',
  },
  'hist.active.user.only': {
    ko: 'Active User Only',
    ja: 'アクティブユーザーのみ',
    en: 'Active User Only',
  },
  'hist.cbo.only': {
    ko: 'CBO Only',
    ja: 'CBOのみ',
    en: 'CBO Only',
  },
  'history.panel.app': {
    ko: '선택된 App/Pkg/Pgm',
    ja: '選択されたAPP/PKG/PGM',
    en: 'Selected App/Pkg/Pgm',
  },
  'history.filter.tcode': {
    ko: "T-Code 조건 입력 ('%'허용)",
    ja: "Tコードの条件を入力('%'許可)",
    en: "Enter a T-Code...(with '%')",
  },
  'history.daily': {
    ko: '일자별 이력 보기',
    ja: '日付別履歴を表示',
    en: 'View Daily History',
  },
  'history.alert.tcode': {
    ko: 'T-Code 또는 Report 명을 입력하세요. T-Code와 Report가 동시에 입력되면 T-Code로 조회됩니다.',
    ja: 'Tコードまたはレポート名を入力してください。Tコードとレポートが同時に入力されると、Tコードで照会されます。',
    en: 'Please, enter the T-Code or Report. If T-Code and Report are input at the same time, it is searched as T-Code.',
  },
  'history.panel.step': {
    ko: '트랜잭션 스텝 목록',
    ja: 'トランザクションステップのリスト',
    en: 'Transaction Step List',
  },
  'hist.title.avg.rollwait': {
    ko: 'Ø Roll Wait',
    ja: 'Ø ロール待機',
    en: 'Ø Roll Wait',
  },
  'history.category': {
    ko: '사용자 분류',
    ja: 'ユーザー分類',
    en: 'User Alphabetically',
  },
  'history.step': {
    ko: '총 스텝수',
    ja: '総ステップ数',
    en: 'T Step',
  },
  'history.begin': {
    ko: '시작 일시',
    ja: '開始日時',
    en: 'Begin DateTime',
  },
  'history.user': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
  },
  // BEGIN::Added.by.KWShin.2026.07.30.
  'history.accs.sstm': {
    ko: '접속 시스템',
    ja: '接続システム',
    en: 'Access System',
  },
  'history.accs.inst': {
    ko: '접속 AP',
    ja: '接続インスタンス',
    en: 'Access Instance',
  },
  'history.accs.count': {
    ko: '접속 횟수',
    ja: '接続回数',
    en: 'Access count',
  },
  'history.accs.on.time': {
    ko: '접속 시작 일시',
    ja: '接続開始日時',
    en: 'Access Start Time',
  },
  'history.accs.off.time': {
    ko: '접속 종료 일시',
    ja: '接続終了日時',
    en: 'Access End Time',
  },
  'history.terminalid': {
    ko: 'IP[Terminal Name]',
    ja: 'IPアドレス[端末名]',
    en: 'IP[Terminal Name]',
  },
  'history.accs.term': {
    ko: '접속 기간',
    ja: '接続期間',
    en: 'Access Period',
  },
  'history.mandt': {
    ko: 'Client',
    ja: 'クライアント',
    en: 'Client',
  },
  'history.account': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'Account',
  },
  'history.bgn.time': {
    ko: '시작 시각',
    ja: '開始時刻',
    en: 'Start Time',
  },
  'history.end.time': {
    ko: '종료 시각',
    ja: '終了時刻',
    en: 'End Time',
  },
  'history.panel.sssn': {
    ko: '접근 세션 목록',
    ja: 'アクセスセッション一覧',
    en: 'Access Session List',
  },
  'history.panel.sssn.step': {
    ko: '접근 세션 내 스텝 목록',
    ja: 'アクセスセッション内のステップ一覧',
    en: 'Step List in Access Session',
  },
  // FINISH::Added.by.KWShin.2026.07.30.
  // BEGIN::Added.by.KWShin.2026.09.03.
  'hist.sssn.time.min': {
    ko: '최소 세션 시간 (s)',
    en: 'Minimum session time (s)',
  },
  'hist.sssn.time.max': {
    ko: '최대 세션 시간 (s)',
    en: 'Maximum session time (s)',
  },
  'hist.ttl.task.type': {
    ko: 'Task type',
    en: 'Task type',
    ja: 'タスクタイプ',
  },
  // FINISH::Added.by.KWShin.2026.09.03.
  // BEGIN::Added.by.KWShin.2026.09.22. User History on ClickHouse 화면 엑셀 내려받기.
  'hist.dnld.title': {
    ko: '다운로드 항목 선택',
    en: 'Select items to download',
    ja: 'ダウンロード項目の選択',
  },
  'hist.dnld.group': {
    ko: '다운로드 항목',
    en: 'Download items',
    ja: 'ダウンロード項目',
  },
  'hist.dnld.user.tree': {
    ko: '모든 사용자의 접속횟수 목록 포함',
    en: 'Include the access count list of all users',
    ja: 'すべてのユーザーの接続回数一覧を含む',
  },
  'hist.dnld.accs.list': {
    ko: '선택된 사용자의 접속 목록 포함',
    en: 'Include the access list of the selected user',
    ja: '選択されたユーザーの接続一覧を含む',
  },
  'hist.dnld.step.list': {
    ko: '선택된 접속 세션 내 스텝 목록 포함',
    en: 'Include the step list in the selected access session',
    ja: '選択されたアクセスセッション内のステップ一覧を含む',
  },
  'hist.dnld.start': {
    ko: '다운로드 시작',
    en: 'Start download',
    ja: 'ダウンロード開始',
  },
  'hist.dnld.cancel': {
    ko: '다운로드 취소',
    en: 'Cancel download',
    ja: 'ダウンロードのキャンセル',
  },
  // FINISH::Added.by.KWShin.2026.09.22.
};
